(function () {
  class ReelSpinnerVisualSCS extends SlotsEngine.types.ReelSpinnerVisual {
    constructor(
      reelId,
      name,
      maxAppertureHeight,
      slotMach,
      minSpacing,
      reservedSpace,
      numPreapp,
      numPostapp,
      dynamicSpinner,
      nudgeReel
    ) {
      super(
        reelId,
        name,
        maxAppertureHeight,
        slotMach,
        minSpacing,
        reservedSpace,
        numPreapp,
        numPostapp,
        dynamicSpinner,
        nudgeReel
      );

      this._reelId = parseInt(reelId.replace('reel', ''));
    }

    startDynamicSpin() {
      super.startDynamicSpin();
    }

    updateSymbolOverlays(ids, overlays) {
      super.updateSymbolOverlays(ids, overlays);

      if (gameController.bonusAntipationActive) {
        for (let i = 0; i < ids.length; i++) {
          if (ids[i] === 14) {
            this.dimSymbol(i, false, 0.0);
          } else {
            this.dimSymbol(i, true, 0.0);
          }
        }
      }

      if (this._reelId === gameData.NUM_REELS && !gameController.bonusAntipationActive) {
        for (let i = 0; i < ids.length; i++) {
          let symId = ids[i];

          if (symId === 15) {
            this.dimSymbol(i, false, 0.0);
          } else {
            this.dimSymbol(i, true, 0.0);
          }
        }
      }
    }

    dimSymbol(row, showDim, duration) {
      super.dimSymbol(row, showDim, duration);
    }

    clearDimSymbolIds(duration) {
      super.clearDimSymbolIds(duration);
    }
  }

  function create(json) {
    let numPreapp = json.numPreappertureSymbols || 2;
    let numPostapp = json.numPostappertureSymbols || 1;
    return new ReelSpinnerVisualSCS(
      json.ID,
      json.ID + ' container',
      json.appertureHeight,
      json.slotMachineName,
      json.minSymbolSpacing,
      1,
      numPreapp,
      numPostapp,
      gameController.dynamicSpinner,
      json.nudgeReel
    );
  }

  function initialise(json, reelSpinnerVisual) {
    reelSpinnerVisual.initialise(json);
  }

  function getRequiredFiles() {
    return [];
  }

  resourceManager.registerObjectType('ReelSpinnerVisualSCS', create, initialise, getRequiredFiles);
})();
